export default "__VITE_ASSET__B0lkZ4rf__"